import React from "react";
import { Box, Grid, Skeleton, Stack } from "@mui/material";
import { SeccionFormulario } from "../../../components/base";

// Texto solo para lectores de pantalla.
const ocultoVisual = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px",
};

// Respeta "reducir movimiento": el esqueleto queda quieto.
const sinAnimacion = {
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};

const CampoEsqueleto = () => (
  <Grid item xs={12} md={6}>
    <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2.5, ...sinAnimacion }} />
  </Grid>
);

/**
 * Esqueleto del formulario de alta de crédito mientras llegan las listas (clientes, periodicidades,
 * gestores y tasas). Mismas secciones que el formulario, para que nada salte al cargar.
 *
 * @param {object} props
 * @param {string} [props.etiqueta] Texto para lectores de pantalla (por defecto "Cargando…").
 */
const CargandoFormulario = ({ etiqueta = "Cargando…" }) => (
  <Box role="status" aria-live="polite">
    <Box component="span" sx={ocultoVisual}>
      {etiqueta}
    </Box>
    <Stack spacing={3} aria-hidden="true">
      <SeccionFormulario titulo="Cliente">
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <Skeleton variant="rounded" height={56} sx={{ borderRadius: 2.5, ...sinAnimacion }} />
          </Grid>
        </Grid>
      </SeccionFormulario>
      <SeccionFormulario titulo="Condiciones">
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <CampoEsqueleto key={i} />
          ))}
        </Grid>
      </SeccionFormulario>
      <SeccionFormulario titulo="Gestor">
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <CampoEsqueleto />
        </Grid>
      </SeccionFormulario>
    </Stack>
  </Box>
);

export default CargandoFormulario;
